const React = require('react');
const { arrayOf, shape, string, number } = require('prop-types');

const Breadcrumb = require('./subcomponents/breadcrumb');
const AppliedFilters = require('./subcomponents/appliedFilters');
const ListFilter = require('./subcomponents/listFilter');
const SwitchFilter = require('./subcomponents/switchFilter');

const { COMPONENT_TYPES, FILTERS_IDS } = require('@pages/V2/utils/constants');

const COMPONENTS_MAP = {
  [COMPONENT_TYPES.radioGroup]: ListFilter,
  [COMPONENT_TYPES.switch]: SwitchFilter,
};

const { getTranslationsBySite } = require('@pages/V2/translations');

const QcatFilters = ({
  availableFilters,
  appliedFilters,
  actualLocation,
  paging,
  pathFromRoot,
  siteId,
  itemsQuantityLimitToShow,
}) => {
  const { filters: translations } = getTranslationsBySite(siteId);
  const total = paging?.total > itemsQuantityLimitToShow ? itemsQuantityLimitToShow : paging?.total;
  const formattedTotal = total?.toLocaleString('es-UY');
  const categoryFilter = appliedFilters?.find((filter) => filter.id === FILTERS_IDS.CATEGORY);

  const getTitle = () => {
    if (categoryFilter) {
      return categoryFilter?.values[0] && categoryFilter.values[0].name;
    }
    return translations.allCategories;
  };

  return (
    <aside className="qcat-filters">
      <Breadcrumb pathFromRoot={pathFromRoot} actualLocation={actualLocation} siteId={siteId} />

      <h1 className="title">{getTitle()}</h1>
      <p className="results-quantity">
        {formattedTotal} {`${translations.product}${formattedTotal === 1 ? '' : 's'}`}
      </p>

      <AppliedFilters appliedFilters={appliedFilters} actualLocation={actualLocation} />

      {availableFilters.map((filter, index) => {
        const Component = COMPONENTS_MAP[filter?.componentType || COMPONENT_TYPES.radioGroup];
        return (
          <Component
            key={filter.id}
            {...filter}
            actualLocation={actualLocation}
            appliedFilters={appliedFilters}
            siteId={siteId}
            filterPosition={index + 1}
            translations={translations}
          />
        );
      })}
    </aside>
  );
};

QcatFilters.propTypes = {
  availableFilters: arrayOf(shape({})),
  appliedFilters: arrayOf(shape({})).isRequired,
  actualLocation: string,
  paging: shape({
    total: number,
  }).isRequired,
};

QcatFilters.defaultProps = {
  availableFilters: [],
  actualLocation: '',
};

module.exports = QcatFilters;
